import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { amplitude } from 'wisestep-api';
import { WsButton, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

import { useWorkspaceContext } from '../../../context';

export interface ISentEmailStatistics {
  sent?: number | string;
  failed?: number | string;
}

interface SentEmailStatsProps {
  statistics: ISentEmailStatistics;
}
export const SentEmailStats = ({ statistics }: SentEmailStatsProps) => {
  const navigate = useNavigate();
  const workspace = useWorkspaceContext();

  return (
    <Stack direction="row" spacing={3}>
      <Stack alignItems="center" spacing={1}>
        <WsTypography
          hoverText="Email sent in last 24 hours"
          variant={WsTypoVariants.BODY1}
          color={WsTypoColors.WHITE}
        >
          Sent Emails
        </WsTypography>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.WHITE}>
          {statistics.sent}
        </WsTypography>
      </Stack>
      <Stack alignItems="center" spacing={1}>
        <WsTypography
          hoverText="Email failed in last 24 hours"
          variant={WsTypoVariants.BODY1}
          color={WsTypoColors.WHITE}
        >
          Failed Emails
        </WsTypography>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.WHITE}>
          {statistics.failed}
        </WsTypography>
      </Stack>
      <Stack alignItems="center" spacing={1}>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.WHITE}>
          Received Emails
        </WsTypography>
        <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.WHITE}>
          Coming Soon
        </WsTypography>
      </Stack>
      <WsButton
        onClick={() => {
          amplitude('Inbox_Filter_View_Analytics', {
            clickedOn: 'View Analytics',
            workspaceName: workspace.name,
            pageName: 'Mail',
            planType: workspace.planType,
            interfaceType: 'web',
            pageUrl: window.location.href,
          });
          navigate('/analytics/communication/emails-analytics');
        }}
        variant="text"
        size="large"
      >
        View Analytics
      </WsButton>
    </Stack>
  );
};
